import React from 'react';
import { connect } from 'react-redux';

import {
    Tooltip,
    Button,
    Menu,
    ListItem,
    ListItemIcon,
    ListItemText,
} from "@material-ui/core";

import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import TranslateIcon from '@material-ui/icons/Translate';

import {
    t,
    changeLanguage,
    currentLanguage,
    getLanguageByCode2,
    getLanguageByLocale,
} from "src/shared_modules/i18n";

import LanguageSwitchItem from "./language-switch-item";

import {
    setCurrentLanguage
} from "src/shared_modules/veu-visitors-core/actions/system";

import { withMatomo } from 'src/shared_modules/veu-visitors-core/components/common/matomo-tracking';

import './language-switch.css';


class LanguageSwitch extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            currLang : currentLanguage(),
            isOpen: false,
            activeLanguages: [],
            anchorMenu : null,
        }
    }

    async componentDidMount() {
        this.open = this.open.bind(this);
        this.close = this.close.bind(this);
        this.clickLanguage = this.clickLanguage.bind(this);

        // get active languages for event because each event has its own language list!!!!
        let actives = [];
        for( let i=0; i < this.props.eventLanguages.length; i++) {
            let lang = getLanguageByLocale( this.props.eventLanguages[i]);
            actives.push(lang);
        }

        let curr = getLanguageByLocale(this.props.currentLang);

        this.setState({
            currLang: curr,
            activeLanguages: actives,
        });
    }

    open(event) {
        if( this.state.activeLanguages.length === 1 )
            return;

        this.setState({
            anchorMenu: event.currentTarget,
            isOpen : true
        });
    }

    close() {
        this.setState({
            anchorMenu: null,
            isOpen : false
        });
    }

    async clickLanguage(code2, index) {

        let current = currentLanguage();

        if( current.code2 !== code2 ) {
            let next = getLanguageByCode2(code2);
            await changeLanguage(code2);

            this.props.trackEvent("language", "change", next.code2 );

            this.props.setCurrentLanguage( next.locale);
            this.setState({ currLang: next });
        }

        this.close();
    }

    renderLanguageItems() {
        let list = this.state.activeLanguages.map( (lang, index )=>{
                let isSelected = false;
                if( lang.code2 === this.state.currLang.code2 )
                    isSelected = true;

                return (<LanguageSwitchItem key={lang.locale} langItem={lang}
                                themedStyle={this.props.themedStyle}
                                isSelected={isSelected}
                                onClick={() => this.clickLanguage(lang.code2, index)}
                    />);
            });

        return (list);
    }

    renderLanguageMenu() {
        return(<Menu id="language-menu"
                    anchorEl={this.state.anchorMenu}
                    anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'center',
                    }}
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: 'center',
                    }}
                    getContentAnchorEl={ null }
                    anchorReference="anchorEl"
                    open={Boolean(this.state.anchorMenu)}
                    onClose={this.close}
                >
                {this.renderLanguageItems()}
            </Menu>);
    }

    renderMobile() {
        let label = this.state.currLang.code2.toUpperCase() + " - "+ this.state.currLang.native;
        let isSingleLang = (this.state.activeLanguages.length === 1 );

        let key = "item-lang-selector"

        return(<React.Fragment>
                    {<ListItem key={key} button disabled={false} onClick={this.open}>
                        <ListItemIcon><TranslateIcon /></ListItemIcon>
                        <ListItemText primary={label} />
                        { isSingleLang ? (null) : [ this.state.isOpen ? <ExpandLessIcon key="less" /> : <ExpandMoreIcon key="more" /> ] }
                    </ListItem>}
                    { this.renderLanguageMenu() }
            </React.Fragment>);
    }

    renderDesktop() {
        let label = this.state.currLang.code2;
        let isSingleLang = (this.state.activeLanguages.length === 1 );
        let tooltip = t("main-nav.language");
        if( isSingleLang  ) {
            tooltip = t("main-nav.one-language");
        }

        return(<React.Fragment>
                <Tooltip title={tooltip}>
                    <Button aria-label="change language"
                            onClick={this.open}
                            color="primary"
                            disabled={false}
                            endIcon={ isSingleLang === false && <ExpandMoreIcon />}
                        >
                        { label }
                    </Button>
                </Tooltip>
                {this.renderLanguageMenu()}
            </React.Fragment>);
    }

    render() {
        let isMobile = Boolean(this.props.mobile);

        return (<React.Fragment>
                    { isMobile && this.renderMobile() }
                    { !isMobile && this.renderDesktop() }
            </React.Fragment>);
    }

}

/*
 * ---------------------------------------------------------------------
 * Redux Container
 * ---------------------------------------------------------------------
 */
const mapStateToProps = ( state, ownProps ) => {
    return {
        eventLanguages: state.event.languages,
        currentLang: state.system.currentLang,
    };
};

const mapDispatchToProps = {
    setCurrentLanguage,
};

/*
 * ---------------------------------------------------------------------
 * Export the redux container
 * ---------------------------------------------------------------------
 */
export default connect(
        mapStateToProps,
        mapDispatchToProps
    )(withMatomo(LanguageSwitch));
